import React, { Fragment, PureComponent, useState } from 'react';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';

import { CategoricalChartState } from "recharts/types/chart/types";

import { WsDecodeBoardInterface, WsDecodeSource } from "../../../../../core/src/interfaces";
import { useHistory } from "react-router-dom";









const COLORS = [ '#d67114', '#4b8409', '#c80100', '#890078', '#026ec6', '#ecd33a' ];
// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const SHADES = [ '#e9e9e9', '#e9e9e9', '#e9e9e9', '#e9e9e9', '#e9e9e9', '#e9e9e9' ];
// const SHADES = [ '#f5f5f5', '#e8e8e8', '#f5f5f5', '#e8e8e8', '#f5f5f5' ];







type WsWheelItem = {
  name:      string;
  score:     number;
  value:     number;
  boardId?:  string;
  metricId?: string
};






// const onMouseEnter = (nextState: CategoricalChartState, event: any) => {
//   console.log('onMouseEnter');
// };



const RADIAN = Math.PI / 180;







const getStartAngle = (data: WsWheelItem[], selectedItem: number) => {

  if (data.length === 3) {

    if (selectedItem === 1) {
      return -30;

    } if (selectedItem === 2) {
      return -150;

    } else {
      return 90;
    }

  } else if (data.length === 6) {

    if (selectedItem === 1) {
      return 30;

    } if (selectedItem === 2) {
      return -30;

    } if (selectedItem === 3) {
      return -90;

    } if (selectedItem === 4) {
      return -150;

    } if (selectedItem === 5) {
      return -210;

    } else {
      return 90;
    }

  } else {

    if (selectedItem === 1) {
      return 18;

    } if (selectedItem === 2) {
      return -54;

    } if (selectedItem === 3) {
      return -126;

    } if (selectedItem === 4) {
      return -198;

    } else {
      return 90;
    }
  }
};












const getRotateLevel2 = (midAngle: any) => {

  if (midAngle === 75) {
    // first contact
    return 14;

  } else if (midAngle === 45) {
    // mean time to resolve
    return 45;

  } else if (midAngle === 15) {
    // proactive resolution
    return 78;

  } else if (midAngle === -15) {
    // service requests automated
    return -70;

  } else if (midAngle === -45) {
    // ticket avoidance
    return -45;



  } else if (midAngle === 3) {
    // uptime
    return -90;

  } else if (midAngle === -27) {
    // device startup time
    return -65;

  } else if (midAngle === -57) {
    // device experience score
    return -30;

  } else if (midAngle === -87) {
    // prod & collab
    return 0;



  } else if (midAngle === -69) {
    // technology adoption
    return -22;

  } else if (midAngle === -99) {
    // digital channel adoption
    return 8;

  } else if (midAngle === -129) {
    // accessible feature usage
    return 38;




  } else if (midAngle === -141) {
    // dwp
    return 50;

  } else if (midAngle === -171) {
    // likes
    return 77;

  } else if (midAngle === -201) {
    // star
    return -70;

  } else if (midAngle === -231) {
    // sentiment feedback
    return -40;

  } else if (midAngle === -261) {
    // engagement feedback
    return -8;




  } else if (midAngle === -213) {
    // quality ideas
    return -60;

  } else if (midAngle === -243) {
    // ideas experimented
    return -30;

  } else if (midAngle === -273) {
    // genai
    return 3;

  } else if (midAngle === -303) {
    // value roi
    return 35;



  } else {
    return 0;
  }
};






const getDyValLevel2 = (midAngle: any, length: number, mapIndex: number) => {

  let val = 5;

  if (midAngle === 75) {
    // first contact
    val = -60;

  } else if (midAngle === 45) {
    // mean time to resolve
    val = -60;

  } else if (midAngle === 15) {
    // proactive resolution
    val = -60;

  } else if (midAngle === -15) {
    // service requests automated
    val = 22;

  } else if (midAngle === -45) {
    // ticket avoidance
    val = 22;



  } else if (midAngle === 3) {
    // uptime
    val = 13;

  } else if (midAngle === -27) {
    // device startup time
    val = 22;

  } else if (midAngle === -57) {
    // device experience score
    val = 22;

  } else if (midAngle === -87) {
    // prod & collab
    val = 22;



  } else if (midAngle === -69) {
    // technology adoption
    val = 22;

  } else if (midAngle === -99) {
    // digital channel adoption
    val = 22;

  } else if (midAngle === -129) {
    // accessible feature usage
    val = 22;




  } else if (midAngle === -141) {
    // dwp
    val = 22;

  } else if (midAngle === -171) {
    // likes
    val = 22;

  } else if (midAngle === -201) {
    // star
    val = -40;

  } else if (midAngle === -231) {
    // sentiment feedback
    val = -60;

  } else if (midAngle === -261) {
    // engagement feedback
    val = -60;




  } else if (midAngle === -213) {
    // quality ideas
    val = -75;

  } else if (midAngle === -243) {
    // ideas experimented
    val = -75;

  } else if (midAngle === -273) {
    // genai
    val = -75;

  } else if (midAngle === -303) {
    // value roi
    val = -62;

  }



  



  if (midAngle > 0 || midAngle < -200) {

    let tspanDy = val + (length * 10);


    if (length === 2 && mapIndex === 1) {

      tspanDy += 55;

    } else if (length === 3 && mapIndex === 1) {

      tspanDy += 58;

    } else if (length === 3 && mapIndex === 2) {

      tspanDy += 57;

    }

    return tspanDy;

  } else {

    const tspanDy = val - (length * 3);

    return tspanDy;
  }
};


















const getScoreDyValLevel2 = (midAngle: any, length: number) => {

  let val = 5;

  if (midAngle === 75) {
    // first contact
    val = 38;

  } else if (midAngle === 45) {
    // mean time to resolve
    val = 39;

  } else if (midAngle === 15) {
    // proactive resolution
    val = 44;

  } else if (midAngle === -15) {
    // service requests automated
    val = -50;

  } else if (midAngle === -45) {
    // ticket avoidance
    val = -45;



  } else if (midAngle === 3) {
    // uptime
    val = -33;

  } else if (midAngle === -27) {
    // device startup time
    val = -50;

  } else if (midAngle === -57) {
    // device experience score
    val = -50;

  } else if (midAngle === -87) {
    // prod & collab
    val = -53;



  } else if (midAngle === -69) {
    // technology adoption
    val = -45;

  } else if (midAngle === -99) {
    // digital channel adoption
    val = -54;

  } else if (midAngle === -129) {
    // accessible feature usage
    val = -50;




  } else if (midAngle === -141) {
    // dwp
    val = -45;

  } else if (midAngle === -171) {
    // likes
    val = -32;

  } else if (midAngle === -201) {
    // star
    val = 43;

  } else if (midAngle === -231) {
    // sentiment feedback
    val = 38;

  } else if (midAngle === -261) {
    // engagement feedback
    val = 37;




  } else if (midAngle === -213) {
    // quality ideas
    val = 35;

  } else if (midAngle === -243) {
    // ideas experimented
    val = 35;

  } else if (midAngle === -273) {
    // genai
    val = 35;

  } else if (midAngle === -303) {
    // value roi
    val = 42;

  }



  const tspanDy = val - (length * 3);

  return tspanDy;
};












const getRotate = (midAngle: any) => {

  if (midAngle === 54) {
    // support
    return 40;

  } else if (midAngle === -18) {
    // performance
    return -68;

  } else if (midAngle === -90) {
    // usage 
    return 0;

  } else if (midAngle === -162) {
    // sentiment
    return 70;

  } else if (midAngle === -234) {
    // innovation
    return -40;

  } else {
    return 0;
  }
};



const getDyVal = (midAngle: any, length: number) => {

  let val = 5;

  if (midAngle === 54) {
    // support
    val = -15;

  } else if (midAngle === -18) {
    // performance
    val = 20;

  } else if (midAngle === -90) {
    // usage
    val = 20;

  } else if (midAngle === -162) {
    // sentiment
    val = 20;

  } else if (midAngle === -234) {
    // innovation
    val = -15;
  }

  const tspanDy = val - (length * 5);

  return tspanDy;
};





const getScoreDyVal = (midAngle: any, length: number) => {

  let val = 5;

  if (midAngle === 54) {
    // support
    val = 35;

  } else if (midAngle === -18) {
    // performance
    val = -25;

  } else if (midAngle === -90) {
    // usage
    val = -25;

  } else if (midAngle === -162) {
    // sentiment
    val = -25;

  } else if (midAngle === -234) {
    // innovation
    val = 35;
  }

  const tspanDy = val - (length * 5);

  return tspanDy;
};




const getPieByLevel = (history: any, data: WsWheelItem[], dataLevel2: WsWheelItem[][], selectedItem: number, state: number, currentItem: number) => {

  const startAngle = getStartAngle(data, selectedItem);

  const angleWidth = selectedItem === state ? 30 : 5;

  let endAngle = startAngle - (dataLevel2[selectedItem]?.length * angleWidth);

  const animation = true;

  const animationBegin = 100;

  const animationDuration = 900;

  return (
    <>
      {
        selectedItem > -1
        &&
        dataLevel2[selectedItem]
        &&
        <Pie
          className={`ws-wheel-outer ws-wheel-selected-item-${selectedItem}-outer`}
          // isAnimationActive={ process.env.NODE_ENV === 'development' ? false : true }
          isAnimationActive={animation}
          animationBegin={animationBegin}
          animationDuration={animationDuration}
          data={dataLevel2[selectedItem]}
          cx={570}
          cy={325}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={160}
          outerRadius={320}
          fill="#8884d8"
          dataKey="value"
          labelLine={false}
        >
          {dataLevel2[selectedItem].map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[selectedItem % COLORS.length]}
              strokeWidth={10}
            />
          ))}
        </Pie>
      }

      {
        selectedItem > -1
        &&
        dataLevel2[selectedItem]
        &&
        <Pie
          className={`ws-wheel-inner ws-wheel-selected-item-${selectedItem}-inner`}
          // isAnimationActive={ process.env.NODE_ENV === 'development' ? false : true }
          isAnimationActive={animation}
          animationBegin={animationBegin}
          animationDuration={animationDuration}
          data={dataLevel2[selectedItem]}
          cx={570}
          cy={325}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={160}
          outerRadius={290}
          fill="#8884d8"
          dataKey="value"

          labelLine={false}

          onClick={(data: any, index: number, e: React.MouseEvent) => {
            // console.log(data);
            // console.log(dataLevel2[selectedItem]?.[index]?.boardId);
            history.push(`/deliver/decode/dashboard/${dataLevel2[selectedItem]?.[index]?.boardId}`);
            // history.push(`/deliver/decode/dashboard/${dataLevel2[selectedItem]?.[index]?.boardId}/metrics/${dataLevel2[selectedItem]?.[index]?.metricId}`);
          }}

          label={state < 0 ? undefined : ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {

            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;

            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            const nameList: string[] = dataLevel2[selectedItem]?.[index]?.name.split('\n');

            // const tspanDy = 5 - (nameList.length * 5);




            const rotate = getRotateLevel2(midAngle);

            const scoreDyVal = getScoreDyValLevel2(midAngle, nameList.length);



            return (
              <text
                transform={`rotate(${rotate} ${x} ${y})`}
                x={x}
                y={y}
                fill="white"
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"

                onClick={() => {

                  if (process.env.NODE_ENV === 'development') {
                    console.log(midAngle);
                  }

                  // console.log(dataLevel2[selectedItem]?.[index]?.boardId);
                  history.push(`/deliver/decode/dashboard/${dataLevel2[selectedItem]?.[index]?.boardId}`);
                  // history.push(`/deliver/decode/dashboard/${dataLevel2[selectedItem]?.[index]?.boardId}/metrics/${dataLevel2[selectedItem]?.[index]?.metricId}`);
                }}

                className="ws-wheel-level-2-label"
                style={{
                  fill: '#453535',
                  textAnchor: 'middle'
                }}
              >
                {
                  nameList.map((value: string, mapIndex: number) => {

                    const dyVal = getDyValLevel2(midAngle, nameList.length, mapIndex);

                    return (
                      <tspan
                        data-index={mapIndex}
                        key={mapIndex}
                        x={x}
                        dy={dyVal + mapIndex}
                        // dy={mapIndex === 0 ? tspanDy : 15}
                        // dangerouslySetInnerHTML={{ __html: value }}
                      >{value}{process.env.NODE_ENV === 'development' ? '' : ''}</tspan>
                    );
                  })
                }
                <tspan x={x} dy={scoreDyVal} className="ws-wheel-segment-score">{(dataLevel2[selectedItem]?.[index]?.score) || ''}</tspan>
              </text>
            );
          }}
        >
          {dataLevel2[selectedItem].map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={SHADES[index % SHADES.length]}
              strokeWidth={10}
            />
          ))}
        </Pie>
      }
    </>
  );
};













type WsWheelRechartsProps = {
  overallScore: number;

  // sourceList: WsDecodeSource[];
  // boardList:  WsDecodeBoardInterface[];
  
  data:       WsWheelItem[];
  dataLevel2: WsWheelItem[][];
  compact?:   boolean;
};

const WsWheelRecharts = ({ overallScore, data, dataLevel2, compact }: WsWheelRechartsProps) => {

  const history = useHistory();

  const [ hoverItem, setHoverItem ] = useState<number>(-1);

  const [ selectedItem, setSelectedItem ] = useState<number>(process.env.NODE_ENV === 'development' ? -1 : -1);

  const [ state, setState ] = useState<number>(process.env.NODE_ENV === 'development' ? -1  : -1);



  const selectItem = (i: number) => {

    if (
      true
      // process.env.NODE_ENV === 'development'
    ) {

      // setState(-1);

      setTimeout(() => {
        setSelectedItem(i);
      }, 100);

      setTimeout(() => {
        setState(i);

        // setTimeout(() => {
        //   setState(-1);
        // }, 3000);
      }, 100);

    } else {

      setSelectedItem(-1);

      setTimeout(() => {
        setSelectedItem(i);
      }, 100);
    }
  };



  const pieHeight = compact ? 400 : 650;

  const pieY = (pieHeight / 2) - 10;



  const getPieBase = () => {

    // const pieY = 350;

    return (
      <>
        <Pie
          isAnimationActive={false}
          data={data}
          cx={570}
          cy={pieY}
          startAngle={90}
          endAngle={-270}
          innerRadius={60}
          outerRadius={180}
          fill="#8884d8"
          dataKey="value"
          labelLine={false}

          onClick={(data: any, index: number, e: React.MouseEvent) => {
            console.log(data);
            console.log(index);
            selectItem(index);
          }}

          onMouseEnter={(data: any, index: number, e: React.MouseEvent) => {
            // setHoverItem(index);
            // console.log(index);
          }}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[index % COLORS.length]}
              strokeWidth={10}
              // stroke="red"
            />
          ))}
        </Pie>

        <Pie
          isAnimationActive={false}
          data={data}
          cx={570}
          cy={pieY}
          startAngle={90}
          endAngle={-270}
          innerRadius={60}
          outerRadius={150}
          fill="#8884d8"
          dataKey="value"

          labelLine={false}

          label={({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {

            // console.log('==========================');
            // console.log(data);
            // console.log(data[index]?.name);
            // console.log(cx, cy);
            // console.log(midAngle);
            // console.log(RADIAN);

            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;

            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            const nameList: string[] = data[index]?.name.split('\n');




            const rotate = getRotate(midAngle);



            return (
              <text
                transform={`rotate(${rotate} ${x} ${y})`}
                x={x}
                y={y}
                fill="white"
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"

                className="ws-wheel-level-1-label"
                style={{
                  fill: '#453535',
                  textAnchor: 'middle'
                }}

                onClick={() => {
                  console.log(data);
                  console.log(index);
                  selectItem(index);
                }}

                onMouseEnter={() => {
                  // setHoverItem(index);
                  // console.log(index);
                }}
              >
                {/* <tspan x={x} y="1.1em">SCORE</tspan> */}
                {/* <tspan x={x} dy="1.2em">{x}</tspan>
                <tspan x={x} dy="1.2em">{y}</tspan> */}
                {
                  nameList.map((value: string, mapIndex: number) => {

                    const dyVal = getDyVal(midAngle, nameList.length);

                    const scoreDyVal = getScoreDyVal(midAngle, nameList.length);

                    // if (mapIndex === 0) {
                    //   // tspanDy
                    // } else {
                    //   dyVal = 25;
                    // }

                    return (
                      <Fragment key={mapIndex}>
                        <tspan
                          x={x}
                          dy={dyVal}
                          // dangerouslySetInnerHTML={{ __html: value }}
                        >{value}{process.env.NODE_ENV === 'development' ? '?' : ''}</tspan>
                        <tspan x={x} dy={scoreDyVal} className="ws-wheel-segment-score">{data[index]?.score || ''}</tspan>
                      </Fragment>
                    );
                  })
                }
              </text>
            );
          }}

          onClick={(data: any, index: number, e: React.MouseEvent) => {
            console.log(data);
            console.log(index);
            selectItem(index);
          }}

          onMouseEnter={(data: any, index: number, e: React.MouseEvent) => {
            // setHoverItem(index);
            // console.log(index);
          }}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={SHADES[index % COLORS.length]}
              // cx={200}
              // cy={500}
              strokeWidth={10}
              // stroke="red"
              className="ws-wheel-level-1"
              // className={ hoverItem === index ? 'ws-wheel-level-1 ws-hover' : 'ws-wheel-level-1' }
            />
            // <Sector key={`cell-${index}`} fill={COLORS[index % COLORS.length]} cx={200} cy={200} />
            // <Sector
            //   key={`sector-${index}`}
            //   cx={200}
            //   cy={200}
            //   innerRadius={60}
            //   outerRadius={80} // Conditional outer radius based on hover state
            //   // startAngle={entry.startAngle}
            //   // endAngle={entry.endAngle}
            //   // fill={entry.fill || '#8884d8'}
            // />
          ))}
        </Pie>
      </>
    );
  };



  const classList: string[] = [ 'ws-wheel' ];

  if (selectedItem > -1) {
    classList.push(`ws-wheel-selected-item-${selectedItem}`);
  }



  return (
    <div className="ws-wheel-page">
      <PieChart
        className={classList.join(' ')}
        width={1140}
        height={pieHeight}
        // onMouseEnter={onMouseEnter}
      >
        {
          compact
          ?
          <></>
          :
          <>
            {
              true
              // process.env.NODE_ENV === 'development'
              ?
              <>
                {getPieByLevel(history, data, dataLevel2, 0, state, selectedItem)}
                {getPieByLevel(history, data, dataLevel2, 1, state, selectedItem)}
                {getPieByLevel(history, data, dataLevel2, 2, state, selectedItem)}
                {getPieByLevel(history, data, dataLevel2, 3, state, selectedItem)}
                {getPieByLevel(history, data, dataLevel2, 4, state, selectedItem)}
                { data.length === 6 && getPieByLevel(history, data, dataLevel2, 5, state, selectedItem)}
              </>
              :
              <>
                {getPieByLevel(history, data, dataLevel2, selectedItem, state, selectedItem)}
              </>
            }
          </>
        }
        {getPieBase()}
      </PieChart>
      <div className="ws-wheel-overall-score">{(overallScore / 10).toFixed(1)}</div>
    </div>
  );
};




export type {
  WsWheelItem
};

export {
  WsWheelRecharts
};
